import React from 'react'

function TenderTextRotary() {
  return (
    <embed src="\pdfs\EAT1.3.2_DB-D-DN_Rotary_floor_twist_outlet_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextRotary